module.exports = __webpack_public_path__ + "static/media/pic.482909de.webp";